import Brands from "@stadium/ui/src/components/brands/web";

import BootStrapDropdown, {
  DropdownItem as BootStrapDropdownItem,
  DropdownToggle as BootStrapDropdownToggle,
} from "@stadium/ui/src/components/bootstrap-dropdown";

import defaultStyles from "./main.module.scss";

interface BrandDropdownProps {
  children?: React.ReactNode;
  renderChildrenAsToggleButton?: boolean;
  dropDownClassName?: string;
  styles?: any;
}

const BrandDropdown = ({
  children,
  renderChildrenAsToggleButton = false,
  dropDownClassName = "",
  styles = defaultStyles,
}: BrandDropdownProps) => {
  const label = renderChildrenAsToggleButton ? (
    <BootStrapDropdownToggle styles={styles}>{children}</BootStrapDropdownToggle>
  ) : (
    <BootStrapDropdownToggle styles={styles} />
  );

  return (
    <>
      {!renderChildrenAsToggleButton && children}
      <BootStrapDropdown styles={styles} label={label} renderOnMount className={dropDownClassName}>
        <BootStrapDropdownItem as="div">
          <Brands />
        </BootStrapDropdownItem>
      </BootStrapDropdown>
    </>
  );
};

export default BrandDropdown;
